<template>
  <ReportsPage
    :product="product"
    :product-data="productData"
    :forecast-subscription="forecastSubscription"
    :esg-subscription="esgSubscription"
    :prices-assessment-subscription="subscription"
  >
    <NuxtPage
      :product="product"
      :product-data="productData"
      :forecast-subscription="forecastSubscription"
      :esg-subscription="esgSubscription"
      :prices-assessment-subscription="subscription"
    />
  </ReportsPage>
</template>

<script setup lang="ts">
import {
  NICKEL,
  MARKET,
  SUBSCRIPTION_PRICE_ASSESSMENTS_NICKEL,
  SUBSCRIPTION_FORECASTS_NICKEL,
  SUBSCRIPTION_ESG_NICKEL,
} from '~/constants/services/constants'
import nickelData from '~/constants/data-reports/nickel'
import ReportsPage from '~/components/market/ReportsPage.vue'

definePageMeta({ layout: 'services' })

const product = ref(NICKEL)
const productData = ref(nickelData)
const forecastSubscription = ref(SUBSCRIPTION_FORECASTS_NICKEL)
const esgSubscription = ref(SUBSCRIPTION_ESG_NICKEL)
const subscription = ref(SUBSCRIPTION_PRICE_ASSESSMENTS_NICKEL)

const { getSeoInfo } = useSeo()
const seo = getSeoInfo({
  title: `${MARKET.name}: ${NICKEL.name} Data and Reports`,
})
useHead(seo)
</script>
